import React, { useState } from 'react'
import styled from 'styled-components'


// Components
import ConfirmModal from '../ConfirmModal/ConfirmModal'
import { PicksSoccerNFL } from './components/PicksSoccerNFL'


export const ResetButton = styled.button`
  background-color: #098af1;
  color: #FFF;
  height: 1.4em;
  border-radius: 0.2em;
  border: 0;
  line-height: 1;
`

export const HeaderPicks = styled.div`
  height: 40px;
  background-color: black;
  border: 1px solid gray;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.9em;
  font-weight: bold;
  font-family: Chivo;
  font-style: italic;
  margin: 0 0.5em;
`

/**
 * This component presents the corresponding fixtures
 * given the week and the entry
 * @const ListFixtures
 */
const ListFixtures = ({
  currentEntry,
  myEntry,
  currentWeek,
  firstOf,
  withRegister,
  selectedWeek,
  entriesInfo,
  handlePick,
  survivorWeeks,
  updateStartedFixture,
  pointFormat,
  survivorInfo,
  allFixtures,
  teams,
  resetPicks,
  removePick,
  previousWeek,
  updateStartedFirstMatchOfWeek
}) => {
  const [showConfirmDelete, setShowConfirmDelete] = useState(false)


    // Regresa un Booleano si se debe mostrar o no el boton de borrar todos los picks
    // Basandose en si existen picks que el usurio puede eliminar (que no hayan comenzado)
    // Si tiene picks que ya pasaron el boton no se reveria de mosstrar
    const getShowRemovePicks = () => {

      if (!myEntry?.survivor_picks) return
    
      return Boolean(Object
          .entries(myEntry.survivor_picks)
          .map(([ weekId, survivor_pick ]) => {
            const pick = survivor_pick.pick 
            const fixture = allFixtures.fixtures[weekId]
            const firstMatch = fixture[0]
            const isUserSelectedFirstMatch = firstMatch.home_team.id === pick || firstMatch.away_team.id === pick
        
            const isPassedDeadlineWeek = fixture?.time_left <= 0
              
            // Fecha de cuando paso el primer partido
            const isPassedFirstMatchDate = firstMatch?.survivor_time_left <= 0
              
            let isDisabled = isPassedDeadlineWeek
                
            // Soccer
            if (survivorInfo.sport_id === 1 && isPassedFirstMatchDate) {
              isDisabled = true
            } else {
              // NFL
              if (isPassedFirstMatchDate && isUserSelectedFirstMatch) {
                isDisabled = true
              } else if (!isUserSelectedFirstMatch && isPassedDeadlineWeek) {
                isDisabled = true
              }
            }
            
            return  !isDisabled ? pick : null
        })
        .find(item => item))
    }


    const showRemovePicks = getShowRemovePicks()

  const showConfirmAll = (e) => {
    e.preventDefault()
    e.stopPropagation()
    setShowConfirmDelete(true)
  }

  const onConfirm = () => {
    resetPicks()
    setShowConfirmDelete(false)
  }

  const onClose = () => {
    setShowConfirmDelete(false)
  }


  return (
    <div>
      <form id="survivorForm">
        {/* Status Survivor */}
        <HeaderPicks>
          <span >SEMANA </span>
          <span >PICK </span>

          <ConfirmModal
            show={showConfirmDelete}
            onConfirm={onConfirm}
            onClose={onClose}
            title='REINICIAR PICKS'
            message='¿Estás seguro que deseas borrar tus picks?'
            message2='Se perderán todos tus picks y no podrás recuperarlos.'
          />
          
          <span >
            {showRemovePicks && (
              <ResetButton onClick={showConfirmAll}>BORRAR PICKS</ResetButton>
            )}
          </span>

          <span >CIERRE </span>

        </HeaderPicks>

        {/* Solo mostrar para deportes que sea Soccer o NFL */}
        {(survivorInfo.sport_id === 6 || survivorInfo.sport_id === 7) && (
          <div className="header-picks-partidos flex-row row-no-padding results" >
            <div
              className={
                'flex-col col-center text-center pick-category ' +
                (pointFormat === 'natural' ? 'col-40' : 'col-30')
              }
            >
              LOCAL
            </div>
            {pointFormat === 'line' ? (
              <div
                className={
                  'flex-col col-center text-center pick-category linea ' +
                  (pointFormat === 'natural' ? 'col-40' : 'col-20')
                }
              >
                LÍNEA
              </div>
            ) : null}
            <div
              className={
                'flex-col col-center pick-category text-center ' +
                (pointFormat === 'natural' ? 'col-40' : 'col-30')
              }
            >
              VISITANTE
            </div>
            <div className="flex-col col-center pick-category text-center">
              {firstOf.enabled ? 'FECHA' : 'RES.'}
            </div>
          </div>
        )}
        

        {/* ------ Control de picks (Soccer/NFL) ------- */}
        <PicksSoccerNFL
          survivorWeeks={survivorWeeks}
          allFixtures={allFixtures}
          handlePick={handlePick}
          removePick={removePick}
          currentEntry={currentEntry}
          teams={teams}
          pointFormat={pointFormat}
          updateStartedFixture={updateStartedFixture}
          survivorInfo={survivorInfo}
          survivorEntryData={myEntry}
          currentWeek={currentWeek}
          previousWeek={previousWeek}
          updateStartedFirstMatchOfWeek={updateStartedFirstMatchOfWeek}
        />
      </form>
    </div>
  );
};

export default ListFixtures;
